import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'gatsby-plugin-intl';
import Layout from '../../components/layout';
import PageContentExpresso from '../../components/PageContentExpresso';
import ImgContentCatalogo from '../../images/mobile.png';
import getConfigRecursosExpressoMobile from '../../data/configRecursosExpressoMobile';

export default ({ location }) => {
  const intl = useIntl();

  const configRecursosExpressoMobile = getConfigRecursosExpressoMobile({ intl });

  return (
    <Layout location={location}>
      <Helmet bodyAttributes={{ class: 'page-template page-template-page-expresso page-template-page-expresso-php page page-id-279 full-width custom-font-enabled single-author mob-menu-slideout' }}>
        <title>{intl.formatMessage({ id: 'Catálogo Expresso Mobile | Ideia 2001' })}</title>
      </Helmet>

      <div id="primary" className="site-content">
        <PageContentExpresso
          titulo={intl.formatMessage({ id: 'Catálogo Expresso Mobile' })}
          Conteudo={() => (
            <>
              <p><img className="right alignnone wp-image-651 imgMobi" src={ImgContentCatalogo} alt="" width="424" height="451" /> {intl.formatMessage({ id: 'Aplicativo para Android e iOS para pesquisa rápida e apresentação de seus produtos, estreitando o relacionamento com seus clientes' })}.</p>
              <p><strong>{intl.formatMessage({ id: 'PLATAFORMAS' })}:</strong> {intl.formatMessage({ id: 'O Aplicativo será desenvolvido para as plataformas Android e iOS (iPhone e iPad), porém, por normas da Apple, para que o aplicativo seja publicado na App Store, sua empresa deverá possuir uma conta na Apple e permitir que a Ideia 2001 administre sua conta (para maiores detalhes estamos à disposição)' })}.</p>
              <p><strong>{intl.formatMessage({ id: 'DISTRIBUIÇÃO' })}: </strong> {intl.formatMessage({ id: 'Catálogo Android através da Play Store; – Catálogo iOS (iPhone e iPad) através da App Store' })}</p>
              <p>&nbsp;</p>
              <p><strong>{intl.formatMessage({ id: 'O QUE É NECESSÁRIO PARA MONTAR UM CATÁLOGO EXPRESSO MOBILE?' })}</strong></p>
              <p>{intl.formatMessage({ id: 'Para montar um Catálogo Expresso Mobile é necessário apenas que os dados de produtos estejam em algum formato eletrônico (EXCEL, Texto, Banco de Dados, etc). Dados em outros formatos (PDF, WORD, etc) serão avaliados' })}.</p>
              <p><strong>{intl.formatMessage({ id: 'QUEM UTILIZA?' })}</strong></p>
              <p>{intl.formatMessage({ id: 'O Catálogo Expresso Mobile foi desenvolvido para o mercado de peças em geral, atendendo' })}<br />
                {intl.formatMessage({ id: 'FABRICANTES e DISTRIBUIDORES' })}.</p>
            </>
          )}
          configRecursos={configRecursosExpressoMobile}
        />
      </div>
    </Layout>
  );
};
